<template>
  <div id="app">
    <router-view></router-view>
    <v-tour
      v-if="isGlobalMode"
      :callbacks="desktopLoggedOutTourCallbacks"
      :options="desktopLoggedOutTourOptions"
      :steps="desktopLoggedOutTourSteps"
      name="desktopLoggedOutTour"
    ></v-tour>
    <sum-up-payment-modal />
    <success-payment-with-q-r-code-modal />
    <pass-buy-modal />
    <offline-modal />
    <digital-external-url-modal />
    <div class="preload">
      <i class="exclamation triangle icon" />
    </div>
  </div>
</template>

<script>
import utils, { logMeIn } from "./utils";
import notify from "./notify";
import sumUpPaymentModal from "@/components/modal/SumUpPaymentModal.vue";
import SuccessPaymentWithQRCodeModal from "@/components/modal/SuccessPaymentWithQRCodeModal.vue";
import config from "@/config";
import PassBuyModal from "@/components/modal/PassBuyModal.vue";
import offlineModal from "@/components/modal/OfflineModal.vue";
import digitalExternalUrlModal from "@/components/modal/DigitalExternalUrlModal.vue";
import cordovaSpecificUtils from "@/specific-cordova/utils";
import defaultSpecificUtils from "@/specific-default/utils";
import moment from "moment";

let specificUtils;
if (config.IS_CORDOVA_APP) {
  specificUtils = cordovaSpecificUtils;
} else {
  specificUtils = defaultSpecificUtils;
}
function getCookie(cname) {
  return specificUtils.getCookie(cname);
}

export default {
  name: "app",
  components: {
    PassBuyModal,
    SuccessPaymentWithQRCodeModal,
    sumUpPaymentModal,
    offlineModal,
    digitalExternalUrlModal,
  },
  data() {
    return {
      desktopLoggedOutTourSteps: [
        /*
        {
          target: '#v-desktop-logged-out-step-0',  // We're using document.querySelector() under the hood
          content: `Regisztrálj és <strong>Jelentkezz be</strong> a foglaláshoz!`
        },
        */
        {
          target: '[data-v-desktop-logged-out-step="1"]', // We're using document.querySelector() under the hood
          content: `Keress pályát kedved szerint`,
        },
        {
          target: '[data-v-desktop-logged-out-step="2"]', // We're using document.querySelector() under the hood
          content: `Szűkítsd a keresésed, derítsd ki hol van <strong>szabad pálya</strong> a közeledben!`,
        },
        {
          target: '[data-v-desktop-logged-out-step="3"]', // We're using document.querySelector() under the hood
          content: `Használd a lista és kártya nézetet a kényelmes kereséshez`,
        },
        {
          target: '[data-v-desktop-logged-out-step="4"]', // We're using document.querySelector() under the hood
          content: `Válassz az elérhető klubbok közül`,
          params: {
            placement: "right",
          },
        },
        {
          target: '[data-v-desktop-logged-out-step="5"]', // We're using document.querySelector() under the hood
          content: `Regisztrálj és jelentkezz be a <strong>foglaláshoz</strong>`,
        },
      ],
      desktopLoggedOutTourOptions: {
        labels: {
          buttonSkip: "Kihagyás",
          buttonPrevious: "Előző",
          buttonNext: "Következő",
          buttonStop: "Befejezés",
        },
      },
      desktopLoggedOutTourCallbacks: {
        onStop: this.desktopLoggedOutTourOnStop,
      },
      isAppMounted: false,
      onNavigatorOnline: navigator.onLine,
    };
  },
  methods: {
    desktopLoggedOutTourOnStop() {
      utils.setTourDone("desktopLoggedOutTour");
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onNavigatorOnline = type === "online";
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    isGlobalMode() {
      return this.$store.state.isGlobalMode;
    },
    isOfflineError() {
      // egy bit, amit beállít: $http hiba || socket hiba || !navigator.online
      return this.$store.state.isOfflineError;
    },
    digitalPOSShow() { return !!this.$store.state.digitalPOSPending || !!this.$store.state.digitalPOSLastError; }

  },
  watch: {
    isAppMounted: function (newVal) {
      if (newVal && this.$store.state.isGlobalMode) {
        let that = this;
        // TODO:  Set timeout TEMP. SOLUTION, FIX IT!
        setTimeout(function () {
          console.log("--- tour-start");
          if (!that.isLoggedIn && !utils.isTourDone("desktopLoggedOutTour")) {
            that.$tours["desktopLoggedOutTour"].start();
          }
        }, 3000);
      }
    },
    isOfflineError(v) {
      if (v && getCookie("isDigital") == "true") {
        this.$modal.show("offline-modal");
      } else {
        this.$modal.hide("offline-modal");
      }
    },
    digitalPOSShow(v) {
      if (v && (getCookie("isDigital") == "true")) {
        this.$modal.show("digital-external-url-modal");
      } else {
        this.$modal.hide("digital-external-url-modal");
      }
    },
    onNavigatorOnline(v) {
      if (!v) {
        this.$store.commit("SET_OFFLINE_ERROR", true);
      }
    },
  },
  created: function () {
    let query = this.$route.query;
    if (
      query.hasOwnProperty("isSocialLogin") &&
      query.hasOwnProperty("isLoginSuccess") &&
      query.hasOwnProperty("userID") &&
      query.hasOwnProperty("token")
    ) {
      if (query.isSocialLogin === "true") {
        if (query.isLoginSuccess === "true") {
          utils.setCookie(
            "userID",
            query.userID,
            300,
            this.$store.state.isGlobalMode
          );
          utils.setCookie(
            "token",
            query.token,
            300,
            this.$store.state.isGlobalMode
          );
          let url = new URL(window.location);
          window.location.href = url.origin;
        } else {
          // alert('google login error')
          notify.warning("Váratlan hiba történt, kérjük próbálja később");
        }
      }
    } else {
      this.$store.dispatch("fetchStartUp");
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // this.$modal.show('pass-buy-modal')
      // DOM updated
      this.isAppMounted = true;
      // console.log('--- nextTick')
      let query = this.$route.query;
      console.log('----- tick  --', query)
      if (query?.msg) {
        let msgType = query?.msgType ? query.msgType : "info";
        if (msgType === "success") {
          notify.success(query.msg);
        } else if (msgType === "error") {
          notify.error(query.msg);
        } else if (msgType === "warning") {
          notify.warning(query.msg);
        } else if (msgType === "successPaymentWithQr") {
          console.log(
            "====================================================",
            query?.closeAfterSecs
              ? Number(query.closeAfterSecs) || false
              : false
          );
          this.$modal.show("success-payment-with-qr-code-modal", {
            url: query.msg,
            closeWindowWhenModalClosed: query?.closeAfterConfirm
              ? Number(query.closeAfterConfirm) === Number(1)
              : false,
            closeAfterSecs: query?.closeAfterSecs
              ? Number(query.closeAfterSecs) || false
              : false,
          });
          delete query.closeAfterSecs;
        } else {
          notify.info(query.msg);
        }
        if (query?.closeAfterConfirm) {
          // TODO: need to to for notification? or not? (maybe PWA solve this problem)
        }
        if (query?.closeAfterSecs) {
          setTimeout(function () {
            window.close();
          }, query.closeAfterSecs * 1000);
        }

        // after msg got clear query
        this.$router.replace({ query: null });
      }

      if (
        window.location.origin.includes("bsquash-digital.foglaljpalyat.hu")
        //|| window.location.origin.includes('teszt.foglaljpalyat.hu')
        //|| window.location.origin.includes('localhost')
      ) {
        if (!this.$store.getters.isLoggedIn) {
          this.$http({
            url: config.SERVER_DOMAIN + "/api/login-digtal",
            method: "POST",
            params: {
              ...this.$store.getters.getAuthParams,
            },
          }).then(
            (resp) => {
              let userID = resp.body.userID;
              let token = resp.body.token;
              const isDigital = resp.body.userType === "digital";
              logMeIn(userID, token, isDigital);
            },
            (error) => {
              utils.httpError(error);
            }
          );
        } // not logged in
        setInterval(() => {
          const today = moment().format("YYYY-MM-DD");
          if (this.$store.state.currentTableDate != today) {
            console.log("digital auto change date to: ", today);
            this.$store.dispatch("setCurrentTableDate", {
              currentTableDate: moment().format("YYYY-MM-DD"),
            });
            this.$store.dispatch("fetchTable");
          }
        }, 1000 * 60 * 30); // 30 percenként
      } // isDigital

      /// ---------- affiliate -----------
      console.log('?????', query);
      if (query?.af) {
          this.$http({
            url: config.SERVER_DOMAIN + "/api/affiliate/hit",
            method: "POST",
            params: {
              ...this.$store.getters.getAuthParams,
              affiliate_token: query.af,
            },
          }).then(
            (resp) => {
              let client = resp.body.client;
              this.$emit('apply-filters', { distanceFilter:  20000 })
              this.$store.dispatch('selectClient', client);
            }/*,
            (error) => {
              utils.httpError(error);
            }*/
          );
          this.$router.replace({ query: null });
      }
    }); // nextTick
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>

<style>
.mx-datepicker {
  display: block !important;
  max-width: 100%;
}

.mx-input {
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif !important;
  border-radius: 0 !important;
  font-size: 1rem !important;
  margin: 0 0.25em 0 0 !important;
  padding: 0.78571429em 1.5em 0.78571429em !important;
  line-height: 1rem !important;
  background: #d6d6d6 !important;
  border: none !important;
  cursor: pointer;
}

.mx-input-append {
  background: #d6d6d6 !important;
  cursor: pointer;
}

.no-result-placeholder {
  color: #a0a9b6;
  font-size: 5rem;
  /*background-color: #5D8D89;*/
  text-align: center;
  /*text-shadow: 0px 1px 0px rgba(255,255,255,.3), 0px -1px 0px rgba(0,0,0,.7);*/
}

.no-result-placeholder h2 {
  margin: 0;
}

.no-result-placeholder h3 {
  margin-bottom: 2rem;
}

/* ---------------------------------- vue - modal ------------------------------------- */
.vue-modal-container.tabos .ui.segment {
  padding: 2px;
}

.vue-modal-container.tabos {
  transition: top 0.3s;
  padding: 3px;
}

.vue-modal-container {
  /* margin-top: 5rem;*/
  background: white;
}

.vue-modal-container .header,
.vue-modal-container .content,
.vue-modal-container .actions {
  padding: 1rem;
}

.vue-modal-container .header {
  border-bottom: 1px solid lightgray;
  color: #0a0a0a;
}

.vue-modal-container .actions {
  border-top: 1px solid lightgray;
  text-align: right;
}

.vue-modal-container .close-modal {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  font-size: 150%;
  color: lightslategrey;
}

.border-radius-0 {
  border-radius: 0 !important;
}

/* ---------------------------------- multi - modal ------------------------------------- */
.multi-modal-container {
  background-color: transparent;
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.multi-modal-container .vue-modal-container {
  margin: 1em;
}

.multi-modal-container .vue-modal-container > .header {
  background-color: #fff;
}

.multi-modal-container .vue-modal-container:not(:first-child) {
  margin-top: 1em;
}
.preload {
  position: fixed;
  overflow: hidden;
  width: 0px;
  height: 0px;
}
</style>

